import { z } from 'zod';
import { stringValidator, userEmailValidator } from '@lucidlink/dto/validation';
export const userLoginSchema = z.object({
    email: userEmailValidator,
    password: stringValidator({
        requiredError: 'user.password.required',
        minLength: { min: 1, error: 'user.password.required' },
    }),
});
